
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_17k0d_99",
  "scrolling-background": "awsui_scrolling-background_hyvsj_17k0d_102",
  "sticky-background": "awsui_sticky-background_hyvsj_17k0d_108",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_17k0d_116",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_17k0d_129",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_17k0d_139",
  "drawers-container": "awsui_drawers-container_hyvsj_17k0d_151",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_17k0d_162",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_17k0d_185",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_17k0d_190",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_17k0d_231",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_17k0d_241",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_17k0d_245",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_17k0d_259",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_17k0d_245",
  "drawer": "awsui_drawer_hyvsj_17k0d_151",
  "drawer-content-container": "awsui_drawer-content-container_hyvsj_17k0d_290",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_17k0d_299",
  "drawer-content": "awsui_drawer-content_hyvsj_17k0d_290",
  "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_17k0d_307",
  "drawer-slider": "awsui_drawer-slider_hyvsj_17k0d_310",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_17k0d_317",
  "content": "awsui_content_hyvsj_17k0d_343",
  "layout": "awsui_layout_hyvsj_17k0d_364",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_17k0d_435",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_17k0d_450",
  "content-type-table": "awsui_content-type-table_hyvsj_17k0d_464",
  "content-type-cards": "awsui_content-type-cards_hyvsj_17k0d_464",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_17k0d_470",
  "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_17k0d_473",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_17k0d_487",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_17k0d_490",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_17k0d_500",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_17k0d_503",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_17k0d_506",
  "has-header": "awsui_has-header_hyvsj_17k0d_506",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_17k0d_524",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_17k0d_524",
  "has-split-panel": "awsui_has-split-panel_hyvsj_17k0d_561",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_17k0d_561",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_17k0d_569",
  "unfocusable": "awsui_unfocusable_hyvsj_17k0d_574",
  "container": "awsui_container_hyvsj_17k0d_584",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_17k0d_610",
  "is-tools-open": "awsui_is-tools-open_hyvsj_17k0d_613",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_17k0d_613",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_17k0d_613",
  "has-active-drawer": "awsui_has-active-drawer_hyvsj_17k0d_613",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_17k0d_622",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_hyvsj_17k0d_639",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_17k0d_643",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_17k0d_647",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_17k0d_651",
  "navigation-container": "awsui_navigation-container_hyvsj_17k0d_660",
  "show-navigation": "awsui_show-navigation_hyvsj_17k0d_698",
  "animating": "awsui_animating_hyvsj_17k0d_721",
  "showButtons": "awsui_showButtons_hyvsj_17k0d_1",
  "navigation": "awsui_navigation_hyvsj_17k0d_660",
  "openNavigation": "awsui_openNavigation_hyvsj_17k0d_1",
  "animated-content": "awsui_animated-content_hyvsj_17k0d_783",
  "hide-navigation": "awsui_hide-navigation_hyvsj_17k0d_792",
  "notifications": "awsui_notifications_hyvsj_17k0d_802",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_17k0d_808",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_17k0d_825",
  "position-bottom": "awsui_position-bottom_hyvsj_17k0d_872",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_17k0d_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_17k0d_901",
  "position-side": "awsui_position-side_hyvsj_17k0d_914",
  "tools-container": "awsui_tools-container_hyvsj_17k0d_936",
  "tools": "awsui_tools_hyvsj_17k0d_936",
  "openTools": "awsui_openTools_hyvsj_17k0d_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_17k0d_1027",
  "hide-tools": "awsui_hide-tools_hyvsj_17k0d_1037",
  "show-tools": "awsui_show-tools_hyvsj_17k0d_1049",
  "has-tools-form": "awsui_has-tools-form_hyvsj_17k0d_1027",
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_17k0d_1132",
  "trigger": "awsui_trigger_hyvsj_17k0d_1132",
  "selected": "awsui_selected_hyvsj_17k0d_1209",
  "badge": "awsui_badge_hyvsj_17k0d_1229",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_17k0d_1233",
  "dot": "awsui_dot_hyvsj_17k0d_1244"
};
  